import React, { useState, useCallback, useContext } from 'react';
import useTranslatedOptions from '@ubeya/shared/hooks/useTranslatedOptions';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';

const PHOTO_VERIFIED_OPTIONS = [
  { label: 'no', value: 0 },
  { label: 'yes', value: 1 }
];

const PhotoVerifiedFilter = ({ defaultValue, handleClose, onApply, search, onChange, hideLayout = false }) => {
  const { t } = useContext(ConfigContext);
  const photoVerifiedOptions = useTranslatedOptions(PHOTO_VERIFIED_OPTIONS);
  const [values, setValues] = useState(defaultValue || []);

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  if (!photoVerifiedOptions.length || (search && !t('verifiedPhoto').toLowerCase().includes(search.toLowerCase()))) {
    return null;
  }

  return (
    <FilterLayout
      name={t('verifiedPhoto')}
      handleClose={handleClose}
      onApply={() => onApply(values)}
      hideLayout={hideLayout}>
      {photoVerifiedOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox
            name={`photo-verified-${value}`}
            value={values.includes(value)}
            label={label}
            onChange={() => handleChange(value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default PhotoVerifiedFilter;
